import { createFileRoute } from '@tanstack/react-router'
import { MaterialIssuesListPage } from '../../../../features/projects/material-issue-pages'
import { materialIssueSearchSchema } from '../../../../features/projects/search'

export const Route = createFileRoute('/_app/projects/material-issues/')({
  validateSearch: materialIssueSearchSchema,
  component: MaterialIssuesListPage,
})
